import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { Dialog, DialogContent, DialogTitle, styled } from '@mui/material'
import { PuiCloseButton, Text } from '@pbt/pbt-ui-components'

const StyledDialogActions = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2.5),
}))

const StyledHeader = styled('div')(({ theme }) => ({
  borderBottom: theme.constants.tableBorder,
}))

const StyledBodyText = styled(Text)(() => ({
  whiteSpace: 'pre-wrap',
}))

interface RhapConfirmCloseDialogProps {
  bodyText?: string
  onCancelClose?: () => void
  onCancelCloseLabel?: string
  onClose: () => void
  onConfirmClose?: () => void
  onConfirmCloseLabel?: string
  open: boolean
  title?: string
}

/**
 * Confirm close dialog with Chirp style buttons and customizable confirm / cancel logic.
 * For legacy component that enforces saving, use ConfirmCloseDialog from pbt-ui-components.
 */
export function RhapConfirmCloseDialog({
  bodyText,
  open,
  onClose,
  onCancelClose,
  onConfirmClose,
  onCancelCloseLabel,
  onConfirmCloseLabel,
  title: titleProp,
}: RhapConfirmCloseDialogProps) {
  const { t } = useTranslation(['Dialogs'])

  const title = titleProp || t('Dialogs:CONFIRM_CLOSE_DIALOG.TITLE')
  const confirmCloseLabel =
    onConfirmCloseLabel || t('Dialogs:CONFIRM_CLOSE_DIALOG.CONFIRM_CLOSE_LABEL')
  const cancelCloseLabel =
    onCancelCloseLabel || t('Dialogs:CONFIRM_CLOSE_DIALOG.CANCEL_CLOSE_LABEL')

  return (
    <Dialog open={open} onClose={onClose}>
      <StyledHeader>
        <DialogTitle>{title}</DialogTitle>
        <PuiCloseButton onClick={onClose} />
      </StyledHeader>
      <DialogContent>
        {bodyText && <StyledBodyText variant="body">{bodyText}</StyledBodyText>}
        <StyledDialogActions>
          {onConfirmClose && (
            <KibButtonNew onClick={onConfirmClose}>
              {confirmCloseLabel}
            </KibButtonNew>
          )}
          {onCancelClose && (
            <KibButtonNew emphasis="secondary" onClick={onCancelClose}>
              {cancelCloseLabel}
            </KibButtonNew>
          )}
        </StyledDialogActions>
      </DialogContent>
    </Dialog>
  )
}
